module.exports = __webpack_public_path__ + "img/newsImg11-9.1273f425.png";